import styled from 'styled-components';

import { ProductDetail } from '@/components/ProductDetail';
import { Typography } from '@/components/Typography';

export const DetailContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  min-height: 800px;
  padding-bottom: 40px;

  [data-test-id='ProductDetailImagesGallery'] {
    min-height: 600px;
  }

  .product-detail-root {
    min-height: 700px;
  }

  /* Make sure there's ample vertical spacing */
  section {
    padding-bottom: 2rem;
  }
`;

export const StyledProductDetail = styled(ProductDetail)`
  min-height: 700px;
`;

export const TechnicalDataContainer = styled.div`
  margin-top: 2rem;
  padding: 0 1rem;
`;

export const TechnicalDataTitle = styled(Typography)`
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
`;

export const TechnicalDataSection = styled.div`
  margin-bottom: 2rem;
`;

export const SectionTitle = styled(Typography)`
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.tertiaryGrey};
  margin-bottom: 1rem;
`;

export const Attribute = styled.div`
  display: flex;
  margin-bottom: 0.75rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const AttributeName = styled(Typography)`
  width: 50%;
  font-weight: bold;
  color: ${(props) => props.theme.colors.darkGrey};

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0.25rem;
  }
`;

export const AttributeValue = styled(Typography)`
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ChangeStrapButtonWrapper = styled.div`
  margin-bottom: 1rem;
`;
